<template>
  <div>
    <LayoutBuilder :url="url" />
    <logout></logout>
    <shortcuts></shortcuts>
  </div>
</template>

<script>
import LayoutBuilder from './layout-builder/LayoutBuilder'
//import Creator from './Creator'
import Logout from '../Logout'
import Shortcuts from './Shortcuts'
import { get } from 'lodash'

/**
 * @class LayoutManager
 *
 * @description This component is a wrapper for the Layout designer and manager tools
 */
export default {
  name: 'LayoutManager',
  data: () => {
    return {
      url: '',
    }
  },
  created: function () {
    this.url = get(this.$CORE, 'url', '')
  },
  components: {
    Shortcuts,
    LayoutBuilder,
    //Creator,
    Logout,
  },
}
</script>
